export default __webpack_public_path__ + "static/0091-209424025d598e965a9d4b91fc9bf63a.png";